import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingIdeogramAiImageGeneratorConfig } from '@/data/landingConfig/landingIdeogramAiImageGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_IdeogramAiImageGenerator } from './schemaObject';

interface Props {}
const IdeogramAiImageGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_IdeogramAiImageGenerator} />
			<LandingTemplate
				data={landingIdeogramAiImageGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageGeneratorV2()}
			/>
		</>
	);
};

export default IdeogramAiImageGenerator;
